import carImg from 'shared/assets/images/transport/car.svg';
import motoImg from 'shared/assets/images/transport/motorcycle.svg';
import truckImg from 'shared/assets/images/transport/lorry.svg';
import busImg from 'shared/assets/images/transport/bus-side.svg';
import trailerImg from 'shared/assets/images/transport/caravan.svg';
import technicsImg from 'shared/assets/images/transport/loader.svg';
import partsImg from 'shared/assets/images/car-parts.svg';

const defaultImages = {
  avto: carImg,
  moto: motoImg,
  mototsikl: motoImg,
  skuter: motoImg,
  baggi: motoImg,
  moped: motoImg,
  kvadrotsikl: motoImg,
  tritsikl: motoImg,
  gruzovye: truckImg,
  avtobus: busImg,
  pritsepy: trailerImg,
  spetstehnika: technicsImg,
  zapchasti: partsImg,
};

export const getDefaultImageByType = transport => {
  if (!transport) {
    return undefined;
  } else if (transport.slug && defaultImages[transport.slug]) {
    return defaultImages[transport.slug];
  } else if (
    transport.parents &&
    transport.parents.length > 0 &&
    defaultImages[transport.parents[0].slug]
  ) {
    return defaultImages[transport.parents[0].slug];
  }

  return undefined;
};

export const getSpareDefaultImage = () => defaultImages.zapchasti;

export default defaultImages;



// WEBPACK FOOTER //
// ./src/shared/constants/defaultImages.js